import React from 'react';
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell,
} from 'recharts';
import { MarketEmptyState } from './MarketEmptyState';

// Hardcoded (not CSS var()) so recharts' inline SVG always renders correctly
// regardless of light/dark theme — matches theme.css accent tokens.
const BAR_COLOR = '#1E6BFF';
const GRID_COLOR = 'rgba(255,255,255,0.08)';
const TEXT_COLOR = '#94A3B8';

function ChartTooltip({ active, payload, label, valueFormatter, sampleLabel }) {
  if (!active || !payload || !payload.length) return null;
  const point = payload[0].payload;
  return (
    <div className="mk-chart-tooltip">
      <div className="mk-chart-tooltip-title">{label}</div>
      <div className="mk-chart-tooltip-value">{valueFormatter ? valueFormatter(point.value) : point.value}</div>
      {typeof point.sampleSize === 'number' && (
        <div className="mk-chart-tooltip-sample">{point.sampleSize} {sampleLabel || 'runners'}</div>
      )}
    </div>
  );
}

/**
 * Vertical bar chart — rating bands / value buckets on X, a chosen metric on Y.
 * @param {Array} data - [{ label, value, sampleSize }]
 */
export const MarketBarChart = ({
  data, valueFormatter = (v) => v, sampleLabel = 'runners',
  emptyMessage = 'Not enough settled races yet to chart this.', height = 260,
}) => {
  const hasData = Array.isArray(data) && data.some(d => d.value != null);
  if (!hasData) {
    return <MarketEmptyState icon="📊" message={emptyMessage} />;
  }

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} margin={{ top: 8, right: 8, left: -12, bottom: 4 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={GRID_COLOR} vertical={false} />
        <XAxis dataKey="label" tick={{ fill: TEXT_COLOR, fontSize: 12 }} axisLine={{ stroke: GRID_COLOR }} tickLine={false} />
        <YAxis tick={{ fill: TEXT_COLOR, fontSize: 12 }} axisLine={false} tickLine={false} tickFormatter={valueFormatter} width={56} />
        <Tooltip
          cursor={{ fill: 'rgba(255,255,255,0.04)' }}
          content={<ChartTooltip valueFormatter={valueFormatter} sampleLabel={sampleLabel} />}
        />
        <Bar dataKey="value" radius={[6, 6, 0, 0]} maxBarSize={48}>
          {data.map((entry, idx) => (
            <Cell key={idx} fill={entry.value == null ? 'rgba(255,255,255,0.08)' : BAR_COLOR} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default MarketBarChart;
